import { useDetailFieldsContext } from '#/components/pages/detail/FieldsSection/atoms/FieldsSectionContext';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Flex, Info, Regular, Tooltip } from '@zazume/zzm-base';
import React, { FC } from 'react';

const TooltipBodyContainer = styled.div(({ theme }) => css`
  white-space: break-spaces;
  width: 12.5rem;
  text-transform: initial;

  ${theme.mq.tablet} {
    width: unset;
  }
`);

const FieldValueContainer = styled(Flex)(() => css`
  grid-column: span 2;
`);

export interface FieldValueBaseProps {
  isDefaultHidden?: boolean;
  title: string;
  tooltip?: string;
  fullWidth?: boolean;
}

export const FieldValueBase: FC<FieldValueBaseProps> = ({ isDefaultHidden, title, tooltip, children, fullWidth }) => {
  const { areSectionsHidden } = useDetailFieldsContext();

  if (isDefaultHidden && areSectionsHidden) {
    return null;
  }

  const TooltipBody = <TooltipBodyContainer>
    <Regular color="White" variant="S">{tooltip}</Regular>
  </TooltipBodyContainer>;

  const Container = fullWidth ? FieldValueContainer : Flex;

  return <Container direction="column" gap="s2">
    <Flex align="center" gap="xs">
      <Regular color="Gray400" variant="S">{title}</Regular>
      {tooltip && (
        <Tooltip name={`${title}-tooltip`} longTextAvailable={true} body={TooltipBody}>
          <Flex><Info size={16} color="Gray400"/></Flex>
        </Tooltip>
      )}
    </Flex>
    {children}
  </Container>;
};
